export default __webpack_public_path__ + "static/media/privacy-policy-kr-2.b0d9775c.jpg";